"use strict";

exports.__esModule = true;
exports.MemCache = void 0;

var _utils = require("@bydesign-ui/utils");

var MemCache = function () {
  function MemCache(direct) {
    this.cache = {};
    this.direct = !!direct;
  }

  var _proto = MemCache.prototype;

  _proto.addCache = function addCache(key, value) {
    if (this.direct) {
      this.cache[key] = value;
      return;
    }

    this.cache[key] = (0, _utils.deepClone)(value);
  };

  _proto.removeCache = function removeCache(key) {
    if (key == null) {
      var all = this.cache;
      this.cache = {};
      return all;
    }

    var res = this.cache[key];
    delete this.cache[key];
    return res;
  };

  _proto.getCache = function getCache(key) {
    var res = key != null ? this.cache[key] : this.cache;

    if (this.direct) {
      return res;
    }

    return (0, _utils.deepClone)(res);
  };

  _proto.hasKey = function hasKey(key) {
    return key in this.cache;
  };

  return MemCache;
}();

exports.MemCache = MemCache;